import { render } from "./Expander.vue?vue&type=template&id=19d35ca2&ts=true"
import script from "./Expander.vue?vue&type=script&lang=ts"
export * from "./Expander.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__